import { TabListCombinedProps } from './types';

const usePresenter = (props: TabListCombinedProps): TabListCombinedProps => {
  return props;
};

export default usePresenter;
